/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { Field } from 'react-final-form';
import { LinkButton, Text } from '@blend/enterprise-components';
import { css, StyleSheet } from 'aphrodite';

import { BlendBridge } from 'blb-types/blendBridge';
import { respondToAuthChallenge } from 'blb-api/auth';
import { FormCard } from 'blb-components/FormCard';
import { SetUser } from 'blb-ui-types/login';
import { useLoginFlowSubmit } from 'blb-utils/login';
import { confirmPhoneNumberInputConfig } from 'blb-inputs/unauthenticated';

import { phoneNumber } from './inputConfigs';

const styles = StyleSheet.create({
  footerWrapper: {
    flex: '1',
  },
});

export namespace PhoneMFAForm {
  export interface Props {
    setMe: SetUser;
    setUseEmailMFA: (bool: boolean) => void;
  }
}

export const PhoneMFAForm: React.FC<PhoneMFAForm.Props> = ({ setMe, setUseEmailMFA }) => {
  const phoneFormValuesTransformer = (formValues: BlendBridge.API.UpdateMFATypeChallenge) => ({
    mfaType: 'SMS_MFA',
    phoneNumber: `+1${formValues.phoneNumber}`,
  });
  const onPhoneMFASubmit = useLoginFlowSubmit(respondToAuthChallenge, setMe, phoneFormValuesTransformer);

  return (
    <FormCard<BlendBridge.API.UpdateMFATypeChallenge>
      additionalFooterComponent={
        <div className={css(styles.footerWrapper)}>
          <Field {...confirmPhoneNumberInputConfig} />
        </div>
      }
      headerLabel={
        <Text>
          Enter a mobile phone number where you can receive SMS codes. You will be texted a code to use each time you
          login.{' '}
        </Text>
      }
      headerTitle="SMS Verification"
      id="SetupMFA-Phone"
      onSubmit={onPhoneMFASubmit}
      showCancel={false}
      submitLabel="Submit"
    >
      <Field {...phoneNumber} />
      <Text fontSize="sm" weight="medium">
        Don’t have a mobile phone number?{' '}
        <LinkButton btnSize="sm" id="it-EmailMFA" inline label="Click here." onClick={() => setUseEmailMFA(true)} />
      </Text>
    </FormCard>
  );
};
